<template lang="pug">
.comment-list(v-if="comments.length > 1")
    .title-comments
        label COMENTARIOS
    .message-wrapper.mb-md( v-for="(comment, index) in comments" )
        b-message( v-if="!comment.is_post_requote && (comment.comment || comment.reason)" :title="comment.user.full_name" type="is-success" )
            .m-b-sm.wrapp
                .comment-column.comment-date {{ dateComment(comment.created) }}
                .premium(v-if="comment.comment")
                  .premium(v-if="comment.comment.premium") Prima neta: {{currencyFormat(comment.comment.premium_currency)}} {{comment.comment.premium}}
                .comment-body(v-if="comment.reason" class="premium") Motivo de Rechazo : {{ comment.reason.description}}
                .comment-body(v-if="comment.comment") {{ comment.comment.text }}
                  div(v-if="comment.comment.attachments")
                    .attachment(v-for="attachment in comment.comment.attachments")
                        a.document(@click="downloadFile(attachment)", target="_blank", :title="attachment.name") {{ attachment.name }}
                b-message.mb-md(v-if="!broker" v-for="reply in comment.messages")
                    .messageText( v-html="reply.text" )
            area-comments(
                v-if="!broker"
                :filteredTags="filteredTags"
                :records="comment"
                :idQuotation="idQuotation"
                :idComment="comment.id"
            )
</template>

<script>
    import { showFileName } from '../services/positiva';
    import { currentUser, isBroker } from '../mixins/user'
    import AreaComments from '../components/AreaComments';
    import S3Service from '../services/s3';

    export default {
        components:{
            AreaComments
        },
        props: {
            comments:{
                type: Array,
            },
            commentQuotation: {
                type: Boolean,
                default: true,
            },
            filteredTags:{
                type: Object,
            },
            idQuotation: {
                type: String,
            }
        },
        computed: {
          broker() {
              return isBroker();
          },
        },
        mounted() {
          //console.log("COMENTARIOS", this.comments)
        },
        methods: {
          dateComment(time) {
            let date = new Date(time)
            return date.toLocaleString("en-GB", { hour12: true })
          },
          currencyFormat(currency) {
            if (currency == "USD") return "$"
            else if (currency = "PEN") return "S/"
          },
          showFileName (name) {
              return showFileName(name, 32, 10)
          },
          parseFileField(field) {
              let isFile = (field.attachment != undefined && field.attachment != "")
              if (isFile && typeof field.attachment === 'string') {
                  let value = field.attachment.replace(/'/g, "\"")
                  field.attachment = JSON.parse(value)
              }
              return isFile
          },
          forward(){
              this.$emit("forward");
          },

          downloadFile(attachment) {
          console.log("download file", attachment);
          S3Service.getQuotationCommentAttachement(attachment.id).then( (response) => {
              console.log("response ", response)
              const {url, name} = response.data
              var element = document.createElement('a');
              element.setAttribute('href', url);
              element.setAttribute('target', '_blank');
              // element.setAttribute('download', name);
              element.style.display = 'none';
              document.body.appendChild(element);

              element.click();

              document.body.removeChild(element);
          })
        }
        }
    }
</script>

<style lang="scss" >
.message-wrapper {
    margin-bottom: 16px;
    .message {
        .message-header {
            .delete {
            display: none !important;
            }
        }
    }
}
.comment-date {
  margin-bottom: 8px;
}
.title-comments {
  margin-bottom: 15px;
}
.premium {
  font-weight: bold;
}
.wrapp {
  margin-bottom: 30px;
}
.comment-list {
  margin-bottom: 32px;
}
</style>
